import { api } from "../apiCore";

export interface EmptyAddressData {
  result: null;
  searchContext: {
    limit: number;
    oneString: string;
    query: string;
  };
}

export interface AddressData {
  cadnum: string;
  contentType: string;
  fullName: string;
  guid: string;
  id: string;
  ifnsfl: string;
  ifnsul: string;
  name: string;
  okato: string;
  oktmo: string;
  parentGuid: string;
  type: string;
  typeShort: string;
  zip: number | null;
}

export const searchAddressApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAddressList: builder.query<
      AddressData[],
      { applicationId: string; applicationBankId: string; queryValue: string }
    >({
      query: ({ applicationId, applicationBankId, queryValue }) => {
        return {
          url: `/auth/applications/system-bank/create-data-to-bank/${applicationId}/application-bank/${applicationBankId}/search-address?query=${queryValue}`,
          method: "GET",
        };
      },
      transformResponse: (res: AddressData[] | EmptyAddressData) => {
        return Array.isArray(res) ? res : [];
      },
    }),
  }),
});

export const { useLazyGetAddressListQuery } = searchAddressApi;
